import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import FooterPrimaryLogo from '../../../assets/images/landking-logo-transparent.png'
import FooterSecondaryLogo from '../../../assets/images/boabah-logo.png'
import './Footer.css'
import { Link } from "react-router-dom"
import { FaInstagram, FaFacebook, FaTwitter, FaLinkedin, FaSnapchat, FaTiktok  } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";



export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="main-footer">
            <Container fluid>
                <Row className="align-items-end logo-row">
                    <Col md={6}>
                        <div className="logo-primary">
                            <img src={FooterPrimaryLogo} />
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="logo-secondary float-md-end">
                            <img src={FooterSecondaryLogo} />
                        </div>
                    </Col>
                </Row>

                <Row className="footer-list-row">
                    <Col md={3}>
                        <h4 className="footer-title">Our Products</h4>
                        <ul className="footer-list">
                            <li>
                                <Link to="/vehicles/h-series">LANDKING H-Series</Link>
                            </li>
                        </ul>
                    </Col>

                    <Col md={3}>
                        <h4 className="footer-title">About BTATC</h4>
                        <ul className="footer-list">
                            <li>
                                <Link to="/about-us">Know More About Us</Link>
                            </li>

                            {/* <li>
                                <Link to="/">News & Updates</Link>
                            </li>


                            <li>
                                <Link to="/">Careers</Link>
                            </li>

                            <li>
                                <Link to="/">BTATC Offers</Link>
                            </li>

                            <li>
                                <Link to="/">BTATC Warranty</Link>
                            </li> */}
                        </ul>
                    </Col>

                    <Col md={3}>
                        <h4 className="footer-title">Useful Links</h4>
                        <ul className="footer-list">
                            <li>
                                <Link to="/">Privacy Policy</Link>
                            </li>

                            <li>
                                <Link to="/">Terms & Conditions</Link>
                            </li>


                            <li>
                                <Link to="/">FAQ's</Link>
                            </li>

                            {/* <li>
                                <Link to="/">Services</Link>
                            </li>

                            <li>
                                <Link to="/">Roadside Assistance</Link>
                            </li> */}
                        </ul>
                    </Col>

                    <Col md={3}>
                        <h4 className="footer-title">Reach Us</h4>

                        <div className="footer-subtitle">
                            <h5>Support Email Address</h5>
                            <a href="#">info@btatc.com</a>
                        </div>

                        <div className="footer-subtitle">
                            <h5>Toll-Free Number</h5>
                            <a href="#" tel="8001240664" >8001240664</a>
                        </div>

                        <ul className="footer-social">
                            <Link to='/'>
                                <li>
                                    <FaInstagram />
                                </li>
                            </Link>

                            <Link to='/'>
                                <li>
                                    <FaFacebook />
                                </li>
                            </Link>

                            <Link to='/'>
                                <li>
                                    <FaSquareXTwitter />
                                </li>
                            </Link>
                        </ul>

                        <ul className="footer-social">
                            <Link to='/'>
                                <li>
                                    <FaLinkedin />
                                </li>
                            </Link>

                            <Link to='/'>
                                <li>
                                    <FaSnapchat />
                                </li>
                            </Link>

                            <Link to='/'>
                                <li>
                                    <FaTiktok />
                                </li>
                            </Link>
                        </ul>

                        {/* <div className="footer-subtitle">
                            <h5>WhatsApp Number</h5>
                        </div> */}
                    </Col>
                </Row>

                <Row className="align-items-center pt-2">
                    <Col md={4}>
                    </Col>
                    <Col md={4}>
                        <div className="footer-copy">
                            <p className="text-white text-center">&copy; {currentYear}. All Rights Reserved by BTATC</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}



